import { tns } from 'node_modules/tiny-slider/src/tiny-slider';

export class JobCarousel {
  constructor() {
    this.initCarousel();
    window.addEventListener('resize', () => this.initCarousel());
  }

  /**
   * Initializes tiny-slider carousel and description components within carousel slide
   * Must be called after stream fetch + soy2js render
   */
  initCarousel() {
    const carouselEl = document.querySelector('.js-jobsCarousel');
    const carouselMobile = document.querySelector('.js-jobsCarouselMobile');
    let isMobile = window.innerWidth <= 991;
    
    const prevArrow = '<span class="Button CarouselSection-prevArrow"><</>';
    const nextArrow = '<span class="Button CarouselSection-nextArrow">></>';

    if (this.slider) {
        this.slider.destroy();
    }


    if (carouselEl && !isMobile) {
        this.slider = tns({
          container: '.js-jobsCarousel',
          items: 4,
          slideBy: 'page',
          nav: false,
          controls: true,
          navPosition: 'bottom',
          controlsPosition: 'bottom',
          controlsText: [prevArrow, nextArrow],
        });
      }

    if (carouselMobile && isMobile) {
        this.slider = tns({
          container: '.js-jobsCarouselMobile',
          items: 1,
          slideBy: 'page',
          nav: true,
          controls: true,
          navPosition: 'bottom',
          controlsPosition: 'bottom',
          controlsText: [prevArrow, nextArrow],
          responsive: {
            768: {
              items: 2,
            },
          },
        });
      }
  }
}